import * as React from "react";

import {
	Show,
	SimpleShowLayout,
	ShowProps,
	BooleanField,
	DateField,
	TextField,
	ReferenceField,
	FunctionField,
} from "react-admin";
import { DOCTOR_SALE_SHARE } from "../constants";
import labelsTranslation from "../translations/tranlation";
import { DOCTORSALE_TITLE_FIELD } from "../doctorSale/DoctorSaleTitle";

export const PatientShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show title={labelsTranslation.userShow.title} {...props}>
			<SimpleShowLayout>
				<FunctionField
					label={"نام و نام خانوادگی"}
					render={(record: any) => `${record.firstName} ${record.lastName}`}
					sortable={false}
				/>
				<TextField label="موبایل" source="mobile" sortable={false} />
				<DateField
					source="createdAt"
					label="تاریخ ثبت"
					locales={"fa-IR"}
					sortable={false}
				/>
				<ReferenceField
					link={false}
					label="تاریخ خرید"
					source="doctorSale.id"
					reference="DoctorSale"
					sortable={false}
				>
					<DateField source="saleDate" locales={"fa-IR"} />
				</ReferenceField>
				<ReferenceField
					link={false}
					label="سهم شما"
					source="doctorSale.id"
					reference="DoctorSale"
					sortable={false}
				>
					<FunctionField
						label="سهم شما"
						render={(record: any) => (record.saleDate ? DOCTOR_SALE_SHARE : 0)}
					/>
				</ReferenceField>
				{/* <BooleanField label="Archived" source="archived" />
				<DateField source="createdAt" label="Created At" />
				<TextField label="Doctor" source="doctor" />
				<TextField label="Doctor Comment" source="doctorComment" />
				<TextField label="Doctor Id" source="doctorId" />
				<ReferenceField
					label="Doctor Sale"
					source="doctorsale.id"
					reference="DoctorSale"
				>
					<TextField source={DOCTORSALE_TITLE_FIELD} />
				</ReferenceField>
				<TextField label="First Name" source="firstName" />
				<TextField label="ID" source="id" />
				<TextField label="Last Name" source="lastName" />
				<TextField label="Mobile" source="mobile" />
				<TextField
					label="Sale Representative Comment"
					source="saleRepresentativeComment"
				/>
				<DateField source="updatedAt" label="Updated At" /> */}
			</SimpleShowLayout>
		</Show>
	);
};
